import React from 'react';
import { getVisibility } from 'framework/utils';
import { useFormContext } from 'framework/form';

interface FormInputGroupProps {
  isVisible?: boolean | ((data: any) => boolean);
  children: React.ReactElement | React.ReactElement[];
}

const FormInputGroup = ({ isVisible, children }: FormInputGroupProps) => {
  const { data } = useFormContext();

  const isSectionsVisible = getVisibility(data, isVisible);

  return isSectionsVisible && children;
};

export default FormInputGroup;
